import { FeaturedPageOut, MappedProductGroup, ProductOut } from '../../../../../store/api';
import { getLocalisedProductGroupTitle } from '../../detail/mappers';

export const mapProductGroups = (
    language: string,
    featuredPage?: FeaturedPageOut,
    products?: { [key: string]: ProductOut[] }
): MappedProductGroup[] => {
    // combines slot, product group, usageStatistics & products of the current feature page

    if (!featuredPage || !products) return [];

    return (
        featuredPage.productGroupSlots?.map(slot => {
            const { productGroup, usageStatistics, ...rest } = slot;
            const { id: productGroupId, ...productGroupRest } = productGroup ?? {};

            const productGroupTitle = getLocalisedProductGroupTitle(productGroup?.titles, language);

            const groupProducts = productGroupId ? products[productGroupId] : [];

            return {
                ...rest,
                ...productGroupRest,
                productGroupId,
                products: groupProducts,
                usageStatistics,
                title: productGroupTitle
            };
        }) ?? []
    );
};
